import { useState, memo } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import {
  WatchlistEntityType,
} from '../../../../generated/graphql'
import { AddCompany } from './AddCompany'

type EmptyWatchlistCardProps = {
  watchlistId: number
  watchlistName: string
  watchlistType?: WatchlistEntityType
}

const EmptyWatchlistCard = memo(function EmptyWatchlistCard(props: EmptyWatchlistCardProps) {
  const [showModal, setShowModal] = useState<boolean>(false)

  return (
    <div
      className='card p-0 h-575px'
      style={{
        boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
        border: '1',
        borderColor: '#F1F1F2',
      }}
    >
      <div className='card-body'>
        <div className='row justify-content-center  text-center py-8 m-6'>
          <img
            alt='no items'
            src={toAbsoluteUrl('/media/icons/duotune/general/empty-watchlist.svg')}
            className='h-250px my-10 w-350 justify-content-center'
          />
          <h1>No companies added to this watchlist</h1>
          <div className='col justify-content-between pt-4'>
            {props.watchlistType !== WatchlistEntityType.Investor && (
              <>
                <button
                  className='btn btn-primary mt-4 mx-8'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_1'
                  onClick={() => setShowModal(!showModal)}
                >
                  Add Company +
                </button>
                {showModal && (
                  <AddCompany
                    showModal={showModal}
                    handleClose={() => setShowModal(false)}
                    watchlistId={props.watchlistId}
                    watchlistName={props.watchlistName}
                    existingCompanies={[]}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})

export { EmptyWatchlistCard }
